
export function shouldTextBeSavedInChatHistory(text, sentMessages) {
    return sentMessages?.at(-1) !== text;
}